import Slice from "./Slice";
import { changeLanguageAction } from "./Sagas";
export * from "./types";
export const { changeLanguage } = Slice.actions;
export { changeLanguageAction };
